import React, { useEffect, useState } from 'react'
import { GetAll_WithFood_Category_Api } from '../../API/CategoryApi';
import { ACategoryComponent } from './ACategoryComponent';

export const FoodPeriodCategoryComponent = (
    {
        setLoading,
        showMessage,
        onClickItems,
    }) => {
    // ======================================================================
    const [categories, setCategories] = useState([]);
        const [categoryId, setCategoryId] = useState(-1);
        const [selectedCategories, setSelectedCategories] = useState([]); // تغییر به آرایه
    // ======================================================================
    useEffect(() => {
        loadData();
    }, []);
    // ======================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetAll_WithFood_Category_Api();
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setCategories(data.messageData.data);
            }
            else {
                showMessage(data.message, "error")
            }
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }

    // تابع جدید برای مدیریت انتخاب/لغو انتخاب دسته‌بندی
    const handleCheckChange = (catId, checked) => {
        if (checked) {
            // افزودن به لیست انتخاب‌شده
            setSelectedCategories(prev => [...prev, catId]);
        } else {
            // حذف از لیست انتخاب‌شده
            setSelectedCategories(prev => prev.filter(id => id !== catId));
        }
    };
    // ======================================================================
    return (
        <>
            <div className='sectionTitle'>
                <h2 >
                    لیست دسته بندی ها
                </h2>
            </div>
            <div className='container'>
                <ul className='category-list'>
                    {
                        categories?.map((category) =>
                            <>
                                <li className='category-item' key={category.id}>
                                    <ACategoryComponent
                                        setLoading={setLoading}
                                        showMessage={showMessage}
                                        category={category}
                                        isShowAddSubCategory={false}
                                        isShowEdit={false}
                                        isShowDelete={false}
                                        isLoadObjectInstanceCategories={false}
                                        isLoadCategoryFromParam={false}
                                        isShowCheckBox={true}
                                        onClickItems={onClickItems}
                                        onCheckChange={handleCheckChange}
                                        isChecked={selectedCategories.includes(category.id)} // ارسال وضعیت انتخاب
                                    />
                                </li>
                            </>
                        )
                    }
                </ul>
            </div>

            {/* دکمه تأیید */}
                <div style={{ marginTop: '20px', textAlign: 'center' }}>
    <button
        className='btn btn-primary'
        onClick={() => {
            if (selectedCategories.length > 0) {
                // پیدا کردن عنوان دسته‌بندی‌های انتخاب‌شده
                const selectedTitles = categories
                    .filter(cat => selectedCategories.includes(cat.id))
                    .map(cat => cat.title)
                    .join('، ');
                
                // ایجاد یک categoryId (مثلاً اولین آیتم انتخاب شده یا -1)
                const firstCategoryId = selectedCategories.length > 0 ? selectedCategories[0] : -1;
                
                // ارسال هر سه پارامتر: firstCategoryId, selectedCategories, selectedTitles
                onClickItems(firstCategoryId, selectedCategories, selectedTitles);
            } else {
                showMessage("لطفاً حداقل یک دسته‌بندی انتخاب کنید", "warning");
            }
        }}
        disabled={selectedCategories.length === 0}
    >
        ادامه با {selectedCategories.length} دسته‌بندی انتخاب‌شده
    </button>
</div>
            
        </>
    )
}
